import React from "react";

const ProfileCard = ({
  image = "/amit-vishnoi.png",
  name = "Amit Vishnoi",
  title = "Director & Buyer's Agent",
  imageClassName = "",
}) => {
  return (
    <div className="flex-shrink-0 w-full max-w-[320px] mx-auto lg:mx-0 flex flex-col items-center">
      <img
        src={image}
        alt={`${name} - ${title}`}
        className={`w-full max-w-[260px] object-contain ${imageClassName}`}
      />
      <div className="text-center mt-2">
        <p className="text-[#003366] text-lg font-semibold">{name}</p>
        <p className="text-gray-600 text-sm -mt-1">{title}</p>
      </div>
    </div>
  );
};

export default ProfileCard;
